import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70b59b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","color":"#1964a6"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物流费用计算参考过程", -1))
const _hoisted_4 = { class: "span-block" }
const _hoisted_5 = {
  key: 0,
  class: "span-block"
}
const _hoisted_6 = {
  key: 1,
  class: "span-block"
}
const _hoisted_7 = {
  key: 2,
  class: "span-block"
}
const _hoisted_8 = {
  key: 3,
  class: "span-block"
}
const _hoisted_9 = {
  key: 4,
  class: "span-block"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "物流费用计算说明", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、体积重量(g)= (长*宽*高cm/8000)*1000；", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、泡重比=体积重量/实际重量；", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、当泡重比≤1.5时，计费重量=实际重量；当泡重比＞1.5时，包裹实际重量和体积重量相比，取较大者为计费重量；", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、物流费用=计费重量*运费/g+操作费/件；", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注：重量和尺寸以我司实际测量为准", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "box-cont" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          justify: "left",
          style: {"border-bottom":"1px solid #ccc"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { style: {"width":"660px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "产品类别",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 }
                        }, _ctx.validateInfos.productType), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              placeholder: "请选择产品类型",
                              getPopupContainer: (triggerNode) => triggerNode.parentNode,
                              value: _ctx.modelRef.productType,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.productType) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "1" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("标准")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "目的国",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 }
                        }, _ctx.validateInfos.destination), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              "show-search": "",
                              getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                              "filter-option": _ctx.filterOption,
                              placeholder: "请选择目的国",
                              onSelect: _ctx.handleSelectDes,
                              value: _ctx.modelRef.destination,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.destination) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylistSet, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.code,
                                    value: item.code
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name) + "(" + _toDisplayString(item.code) + ")", 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "filter-option", "onSelect", "value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "揽收方式",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 }
                        }, _ctx.validateInfos.deliveryType), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              placeholder: "请选择揽收方式",
                              getPopupContainer: (triggerNode) => triggerNode.parentNode,
                              value: _ctx.modelRef.deliveryType,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.deliveryType) = $event)),
                              onChange: _ctx.handleDeliveryType
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "1" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("上门揽收")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "2" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("自送/邮寄")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "value", "onChange"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "揽收城市",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 }
                        }, _ctx.validateInfos.city), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              "show-search": "",
                              getPopupContainer: triggerNode => triggerNode.parentNode,
                              "filter-option": _ctx.filterOption,
                              placeholder: "请选择揽收城市",
                              value: _ctx.modelRef.city,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.city) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newArealist, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.id,
                                    value: item.city
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.city), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "filter-option", "value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹重量",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 },
                          style: {"display":"flex"}
                        }, _ctx.validateInfos.weightVal), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.modelRef.weightVal,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.weightVal) = $event)),
                              placeholder: "包裹重量范围在1-15000",
                              style: {"flex":"1"},
                              "addon-after": "g",
                              min: "1",
                              max: "15000"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹体积",
                          labelCol: { span: 6 },
                          wrapperCol: { span: 18 },
                          style: {"display":"flex"}
                        }, _ctx.validateInfos.length), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.modelRef.length,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.length) = $event)),
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              min: "1",
                              max: "150",
                              placeholder: "请输入长",
                              style: {"flex":"1"},
                              "addon-after": "cm"
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_input_number, {
                              value: _ctx.modelRef.width,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.width) = $event)),
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              min: "1",
                              max: "150",
                              placeholder: "请输入宽",
                              style: {"flex":"1"},
                              "addon-after": "cm"
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_input_number, {
                              value: _ctx.modelRef.height,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.height) = $event)),
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              min: "1",
                              max: "150",
                              placeholder: "请输入高",
                              style: {"flex":"1"},
                              "addon-after": "cm"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          value: _ctx.modelRef.flag,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelRef.flag) = $event)),
                          onChange: _ctx.handleChangeForever,
                          style: {"flex":"1","margin-left":"0px","margin-top":"5px","float":"left"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("体积重试算")
                          ]),
                          _: 1
                        }, 8, ["value", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { class: "box-Center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              "html-type": "submit",
                              type: "primary",
                              onClick: _ctx.postFromData,
                              loading: _ctx.submitLoading
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("计算")
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"]),
                            _createVNode(_component_a_button, {
                              "html-type": "button",
                              style: {"margin":"0 8px"},
                              onClick: _ctx.handleRest
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("重置")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"border-bottom":"1px solid #ccc","padding-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              justify: "center",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, { style: {"width":"100%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, { gutter: 14 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 14 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  style: {"width":"100%"},
                                  label: "实重物流费用",
                                  labelCol: { span: 10 },
                                  wrapperCol: { span: 10 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.freightCalculationDataInfoList.actualPrice,
                                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.freightCalculationDataInfoList.actualPrice) = $event)),
                                      "addon-after": "RMB"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: 14 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 14 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "体积重物流费用",
                                  labelCol: { span: 10 },
                                  wrapperCol: { span: 10 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      "addon-after": "RMB",
                                      value: _ctx.freightCalculationDataInfoList.volumeWeightPrice,
                                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.freightCalculationDataInfoList.volumeWeightPrice) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "泡重比",
                                  labelCol: { span: 10 },
                                  wrapperCol: { span: 10 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.freightCalculationDataInfoList.calculationBubbleRatio,
                                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.freightCalculationDataInfoList.calculationBubbleRatio) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: 14 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 14 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "计费重物流费用",
                                  labelCol: { span: 10 },
                                  wrapperCol: { span: 10 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      "addon-after": "RMB",
                                      value: _ctx.freightCalculationDataInfoList.billingPrice,
                                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.freightCalculationDataInfoList.billingPrice) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("span", _hoisted_4, " 实重物流费用 = " + _toDisplayString((_ctx.modelRef.weightVal || 0)) + "g * " + _toDisplayString((_ctx.numAdd(_ctx.freightCalculationDataInfoList.weightPrice,_ctx.freightCalculationDataInfoList.diversityWeightPrice) || 0)) + " 元/g + " + _toDisplayString((_ctx.numAdd(_ctx.freightCalculationDataInfoList.unitPrice, _ctx.freightCalculationDataInfoList.diversityUnitPrice)|| 0)) + " 元 = " + _toDisplayString((_ctx.freightCalculationDataInfoList.actualPrice || 0)) + "元 ", 1),
                      (_ctx.isFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "泡重比 = (" + _toDisplayString((_ctx.modelRef.length || 0)) + "*" + _toDisplayString((_ctx.modelRef.width || 0)) + "*" + _toDisplayString((_ctx.modelRef.height || 0)) + " / " + _toDisplayString((_ctx.freightCalculationDataInfoList.checkParam || 0)) + ") * 1000 / " + _toDisplayString(_ctx.modelRef.weightVal) + " = " + _toDisplayString(_ctx.freightCalculationDataInfoList.calculationBubbleRatio || 0), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "体积重 = (" + _toDisplayString((_ctx.modelRef.length || 0)) + "*" + _toDisplayString((_ctx.modelRef.width || 0)) + "*" + _toDisplayString((_ctx.modelRef.height || 0)) + " / " + _toDisplayString((_ctx.freightCalculationDataInfoList.calcParam || 0)) + ") * 1000 = " + _toDisplayString((_ctx.freightCalculationDataInfoList.volumeWeight || 0)) + " g ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.isFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "体积重物流费用 = " + _toDisplayString((_ctx.freightCalculationDataInfoList.volumeWeight || 0)) + "g * " + _toDisplayString((_ctx.numAdd(_ctx.freightCalculationDataInfoList.bulkWeightPrice,_ctx.freightCalculationDataInfoList.bulkDiversityWeightPrice) || 0)) + " 元/g + " + _toDisplayString((_ctx.numAdd(_ctx.freightCalculationDataInfoList.bulkUnitPrice,_ctx.freightCalculationDataInfoList.bulkDiversityUnitPrice) || 0)) + " 元 = " + _toDisplayString((_ctx.freightCalculationDataInfoList.volumeWeightPrice || 0)) + "元 ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.isFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "计费重物流费用 = " + _toDisplayString((_ctx.freightCalculationDataInfoList.billingPrice || 0)) + "元", 1))
                        : _createCommentVNode("", true),
                      (!_ctx.isFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "该参数下的包裹，体积重不参与物流费用计算"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, {
          justify: "center",
          style: {"padding-top":"30px"},
          class: "tips-txt"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}